const Reflux = require('@muzzylane/reflux');

const ServerRequest = require('./request');

const FeaturedDemoActions = Reflux.createActions({
    getAll: { children: ['completed', 'failed'] },
});

FeaturedDemoActions.getAll.listen(function(actionId, params={}) {
    ServerRequest.makeRequest('/authoring/featured_demos', 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

module.exports = FeaturedDemoActions;